import { useState } from 'react';
import { Popover, ActionIcon } from '@mantine/core';
import './DotMenu.css';

export interface DotMenuItem {
  label: string;
  onClick: () => void;
  isDanger?: boolean;
  disabled?: boolean;
  title?: string;
}

export interface DotMenuProps {
  items: DotMenuItem[];
  inverted?: boolean;
}

export default function DotMenu({ items, inverted = false }: DotMenuProps) {
  const [opened, setOpened] = useState(false);

  const handleItemClick = (onClick: () => void) => {
    setOpened(false);
    onClick();
  };

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <Popover
      position="bottom-end"
      withArrow
      shadow="md"
      opened={opened}
      onChange={setOpened}
    >
      <Popover.Target>
        <ActionIcon
          variant="default"
          color="gray"
          size="sm"
          className={`dot-menu-trigger ${inverted ? 'dot-menu-trigger--inverted' : ''}`}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setOpened((o) => !o);
          }}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="8" cy="4" r="1.5" />
            <circle cx="8" cy="8" r="1.5" />
            <circle cx="8" cy="12" r="1.5" />
          </svg>
        </ActionIcon>
      </Popover.Target>
      <Popover.Dropdown className="dot-menu-dropdown">
        <div className="dot-menu-content">
          {items.map((item, index) => (
            <button
              key={index}
              type="button"
              className={`dot-menu-item ${item.isDanger ? 'dot-menu-item--danger' : ''}`}
              disabled={item.disabled}
              title={item.title}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (item.disabled) return;
                handleItemClick(item.onClick);
              }}
            >
              {item.label}
            </button>
          ))}
        </div>
      </Popover.Dropdown>
    </Popover>
  );
}
